var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithdrawalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.25H2.5C2.09 9.25 1.75 8.91 1.75 8.5C1.75 8.09 2.09 7.75 2.5 7.75H15C15.41 7.75 15.75 8.09 15.75 8.5C15.75 8.91 15.41 9.25 15 9.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17.25H6.5C6.09 17.25 5.75 16.91 5.75 16.5C5.75 16.09 6.09 15.75 6.5 15.75H8.5C8.91 15.75 9.25 16.09 9.25 16.5C9.25 16.91 8.91 17.25 8.5 17.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17.25H11C10.59 17.25 10.25 16.91 10.25 16.5C10.25 16.09 10.59 15.75 11 15.75H15C15.41 15.75 15.75 16.09 15.75 16.5C15.75 16.91 15.41 17.25 15 17.25Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.06 21.25H6.94C2.96 21.25 1.75 20.05 1.75 16.11V7.89C1.75 3.95 2.96 2.75 6.94 2.75H15C15.41 2.75 15.75 3.09 15.75 3.5C15.75 3.91 15.41 4.25 15 4.25H6.94C3.8 4.25 3.25 4.79 3.25 7.89V16.1C3.25 19.2 3.8 19.74 6.94 19.74H18.05C21.19 19.74 21.74 19.2 21.74 16.1V14.02C21.74 13.61 22.08 13.27 22.49 13.27C22.9 13.27 23.24 13.61 23.24 14.02V16.1C23.25 20.05 22.04 21.25 18.06 21.25Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10.2499C20.09 10.2499 19.75 9.90994 19.75 9.49994V3.49994C19.75 3.19994 19.93 2.91994 20.21 2.80994C20.49 2.69994 20.81 2.75994 21.03 2.96994L23.03 4.96994C23.32 5.25994 23.32 5.73994 23.03 6.02994C22.74 6.31994 22.26 6.31994 21.97 6.02994L21.25 5.30994V9.49994C21.25 9.90994 20.91 10.2499 20.5 10.2499Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4999 6.25043C18.3099 6.25043 18.1199 6.18043 17.9699 6.03043C17.6799 5.74043 17.6799 5.26043 17.9699 4.97043L19.9699 2.97043C20.2599 2.68043 20.7399 2.68043 21.0299 2.97043C21.3199 3.26043 21.3199 3.74043 21.0299 4.03043L19.0299 6.03043C18.8799 6.18043 18.6899 6.25043 18.4999 6.25043Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawalIcon);
export default __webpack_public_path__ + "static/media/withdrawalIcon.22bee0254702ccb3750066ec6d37f7d9.svg";
export { ForwardRef as ReactComponent };